import { WidgetFormLabel } from "@components/WAChatbutton/WAform/WidgetForm";
import Image from "next/image";
import React, { useState, useEffect, forwardRef } from "react";

interface FormLogoProps {
    version: string;
    error?: string;
    handleCallback: (data: string) => void;
    inputRef?: React.Ref<HTMLInputElement>;
}

const defaultLogo = [
    "https://assets.gallabox.com/gb-home/wa-chat-widget/bot-logo-1.png",
    "https://assets.gallabox.com/gb-home/wa-chat-widget/bot-logo-2.png",
    "https://assets.gallabox.com/gb-home/wa-chat-widget/bot-logo-3.png",
    "https://assets.gallabox.com/gb-home/wa-chat-widget/bot-logo-4.png",
    "https://assets.gallabox.com/gb-home/wa-chat-widget/bot-logo-5.png",
    "https://assets.gallabox.com/gb-home/wa-chat-widget/bot-logo-6.png",
];
const inputStyle: React.CSSProperties = { padding: "10px", margin: "0" };
const errMsgFocusStyle: React.CSSProperties = { outline: "1px solid rgba(239, 68, 68, 0.5)" };

const FormLogo = forwardRef<HTMLInputElement, FormLogoProps>(({ handleCallback, inputRef, error, version }) => {
    FormLogo.displayName = "FormLogo";
    const [clickIndex, setClickIndex] = useState<number>(0);
    const [fileName, setFileName] = useState("");
    const logoFile = (e: any) => {
        const file = e.target.value;
        setFileName(file);
        handleCallback(file);
    };
    const defaultLogoClick = (logo: any, index: number) => {
        setClickIndex(index);
        handleCallback(logo);
    };
    useEffect(() => {
        setClickIndex(0);
    }, [version]);
    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
                <WidgetFormLabel htmlFor="logo">Your Logo</WidgetFormLabel>
                <input
                    id="logo"
                    type="text"
                    placeholder="Logo URL"
                    style={{ ...inputStyle, ...(error ? errMsgFocusStyle : {}) }}
                    className="text-base font-normal"
                    value={fileName}
                    onChange={(e) => logoFile(e)}
                    ref={inputRef}
                />
            </div>

            <p className="text-center text-xl font-medium text-gray-700">(OR)</p>

            <div className="flex justify-between items-start">
                {defaultLogo.map((logo, index) => (
                    <div key={index}>
                        <button
                            type="button"
                            aria-label="pick logo"
                            data-cy={`avatar ${index}`}
                            className={
                                clickIndex === index
                                    ? "flex items-center justify-center border-solid border-2 rounded-full w-12 h-12 md:w-16 md:h-16 xl:w-20 xl:h-20 focus:outline-none ring-1 border-blue-400"
                                    : "flex items-center justify-center border-solid border-2 border-gray-200 rounded-full w-12 h-12 md:w-16 md:h-16 xl:w-20 xl:h-20 focus:outline-none"
                            }
                            onClick={() => defaultLogoClick(logo, index)}
                        >
                            <Image src={logo} alt="defaultLogo" width={70} height={70} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
});

export default FormLogo;
